@if (isDisplayComponent()) {
    <mat-expansion-panel #panel hideToggle [disabled]="!isExpandable()" [expanded]="!vm().isExpanded">
        <mat-expansion-panel-header>
            <mat-panel-title (libAccessibleClick)="panel.toggle()">
                <ng-container [ngTemplateOutlet]="title"></ng-container>
            </mat-panel-title>
            @if (isExpanded()) {
                <mat-panel-description>
                    @if (panel.expanded) {
                        <mat-icon svgIcon="ico_minus"></mat-icon>
                    } @else {
                        <mat-icon svgIcon="ico_plus"></mat-icon>
                    }
                </mat-panel-description>
            }
        </mat-expansion-panel-header>

        <p class="description body-1">
            <ng-container [ngTemplateOutlet]="content"></ng-container>
        </p>
    </mat-expansion-panel>
}

<ng-template #title>
    @if (vm().isTitleTemplate) {
        <ng-container [ngTemplateOutlet]="vm().titleTemplate"></ng-container>
    } @else {
        <h2 class="heading-3" [attr.aria-label]="vm().title + ' Accordion'">
            {{ vm().title }}
        </h2>
    }
</ng-template>

<ng-template #content>
    @if (vm().isLoadingContent) {
        <div class="skeleton-wrapper">
            <ng-container *ngTemplateOutlet="skeletonService.rectangleTemplate()"></ng-container>
        </div>
    } @else {
        @if (vm().isContentTemplate) {
            <ng-container [ngTemplateOutlet]="vm().contentTemplate"></ng-container>
        } @else {
            <div class="body-0">
                @if (isArrayOfObjectsProvided()) {
                    <div class="items-stack-wrapper">
                        @for (item of vm().content; track item) {
                            <p>{{ item }}</p>
                        }
                    </div>
                } @else {
                    {{ vm().content }}
                }
            </div>
        }
    }
</ng-template>
